(function () {
  'use strict';

  var NS = 'http://www.w3.org/2000/svg';
  var uid = 0;

  var CX = 500, CY = 500;
  var GRP_IN = 208, GRP_OUT = 265;
  var CAT_IN = 279, CAT_OUT = 351;
  var TICK_IN = 363, TICK_OUT = 430;

  var GRP_GAP = 3;
  var CAT_GAP = 1.5;

  var GROUP_ORDER = ['Cancer', 'Cardiac', 'Additional'];

  function el(name, attrs) {
    var e = document.createElementNS(NS, name);
    for (var k in attrs) e.setAttribute(k, attrs[k]);
    return e;
  }
  function polar(r, a, k) {
    var rad = a * Math.PI / 180;
    return [(CX + r * Math.sin(rad)) / k, (CY - r * Math.cos(rad)) / k];
  }
  function f(p, d) { return p[0].toFixed(d) + ' ' + p[1].toFixed(d); }
  function sector(a0, a1, ri, ro, k) {
    k = k || 1;
    var d = k === 1 ? 2 : 5;
    var large = (a1 - a0) > 180 ? 1 : 0;
    var RO = (ro / k).toFixed(d), RI = (ri / k).toFixed(d);
    return 'M' + f(polar(ro, a0, k), d) + 'A' + RO + ' ' + RO + ' 0 ' + large + ' 1 ' + f(polar(ro, a1, k), d) +
           'L' + f(polar(ri, a1, k), d) + 'A' + RI + ' ' + RI + ' 0 ' + large + ' 0 ' + f(polar(ri, a0, k), d) + 'Z';
  }
  function num(v, fallback) {
    var n = parseFloat(v);
    return isFinite(n) ? n : fallback;
  }
  function list(v) {
    return (v || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function groupOf(name) {
    var G = window.US_PANEL_GROUPS;
    if (G && G.of) return G.of(name);
    var n = (name || '').toLowerCase();
    if (n.indexOf('cancer') > -1) return 'Cancer';
    if (n.indexOf('heart') > -1 || n.indexOf('cardio') > -1 ||
        n.indexOf('rhythm') > -1 || n.indexOf('circulation') > -1) return 'Cardiac';
    return 'Additional';
  }

  function place(root) {
    var box = root.querySelector('.us-dial__box');
    if (!box) return;
    var rb = root.getBoundingClientRect(), bb = box.getBoundingClientRect();
    if (!rb.width || !rb.height || !bb.width) return;
    var k = parseFloat(getComputedStyle(root).getPropertyValue('--dial-label-r'));
    if (!isFinite(k)) k = 1.02;
    var R = bb.width * 0.43 * k;
    var cx = bb.left + bb.width / 2 - rb.left;
    var cy = bb.top + bb.height / 2 - rb.top;
    Array.prototype.forEach.call(root.querySelectorAll('.us-dial__label'), function (n) {
      if (n.classList.contains('us-dial__spot-label')) return;
      var s = parseFloat(n.style.getPropertyValue('--sin'));
      var c = parseFloat(n.style.getPropertyValue('--cos'));
      if (!isFinite(s) || !isFinite(c)) return;
      var x = cx + R * s;
      var w = n.offsetWidth, pad = 8;
      if (w) {
        if (n.classList.contains('us-dial__label--left')) x = Math.max(x, w + pad);
        else x = Math.min(x, rb.width - w - pad);
      }
      n.style.left = (x / rb.width * 100).toFixed(3) + '%';
      n.style.top = ((cy - R * c) / rb.height * 100).toFixed(3) + '%';
    });
  }

  function spotlight(root, lit) {
    if (root.getAttribute('data-spotlight') !== 'on') return;
    if (!lit.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var HOLD = num(root.getAttribute('data-spotlight-hold'), 2000);
    var GAP = 400;

    var tag = document.createElement('span');
    tag.className = 'us-dial__label us-dial__spot-label';
    root.appendChild(tag);

    var i = -1, timer = null, on = false, visible = false;

    function clear() {
      if (i < 0) return;
      lit[i].arc.classList.remove('is-lit');
      lit[i].ticks.forEach(function (t) { t.classList.remove('is-lit'); });
      tag.classList.remove('is-on');
    }
    function step() {
      if (on) {
        clear();
        on = false;
        timer = setTimeout(step, GAP);
        return;
      }
      i = (i + 1) % lit.length;
      var c = lit[i];
      c.arc.classList.add('is-lit');
      c.ticks.forEach(function (t) { t.classList.add('is-lit'); });
      tag.textContent = c.name;
      tag.classList.add('is-on');
      on = true;
      timer = setTimeout(step, HOLD);
    }
    function start() { if (timer == null) timer = setTimeout(step, 400); }
    function stop() { clearTimeout(timer); timer = null; clear(); on = false; }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting === visible) return;
          visible = e.isIntersecting;
          visible ? start() : stop();
        });
      }, { rootMargin: '0px 0px -5% 0px' }).observe(root);
    } else {
      start();
    }
  }

  function draw(root) {
    var svg = root.querySelector('.us-dial__svg');
    if (!svg || !window.US_PANEL || !window.US_PANEL.categories) return false;

    var cats = window.US_PANEL.categories
      .filter(function (c) { return c && c.count > 0; })
      .map(function (c) { return { name: c.name, count: c.count, group: groupOf(c.name) }; });
    if (!cats.length) return false;

    var order = (window.US_PANEL_GROUPS && window.US_PANEL_GROUPS.order) || GROUP_ORDER;
    cats.sort(function (a, b) { return order.indexOf(a.group) - order.indexOf(b.group); });

    var families = order.map(function (g) {
      var members = cats.filter(function (c) { return c.group === g; });
      var G = window.US_PANEL_GROUPS;
      return { name: (G && G.label) ? G.label(g) : g, key: g, cats: members, count: members.reduce(function (s, c) { return s + c.count; }, 0) };
    }).filter(function (g) { return g.cats.length; });

    var total = cats.reduce(function (s, c) { return s + c.count; }, 0);

    var a0 = num(root.getAttribute('data-arc-from'), -134);
    var a1 = num(root.getAttribute('data-arc-to'), 80);
    var sweep = a1 - a0;

    var unit = (sweep - GRP_GAP * (families.length - 1) - CAT_GAP * (cats.length - families.length)) / total;
    if (!(unit > 0)) return false;

    while (svg.firstChild) svg.removeChild(svg.firstChild);

    var glass = [];

    var VOID_GAP = 3;
    var wedge = el('path', { d: sector(a1 + VOID_GAP, a0 + 360 - VOID_GAP, GRP_IN, TICK_OUT), 'class': 'us-dial__void' });
    var wt = el('title', {});
    wt.textContent = 'Not yet reported';
    wedge.appendChild(wt);
    svg.appendChild(wedge);
    glass.push(sector(a1 + VOID_GAP, a0 + 360 - VOID_GAP, GRP_IN, TICK_OUT, 1000));

    var ghost = el('g', { 'class': 'us-dial__ghost' });
    ghost.appendChild(el('circle', { cx: CX, cy: CY, r: TICK_OUT }));
    svg.appendChild(ghost);

    var cursor = a0, tickIndex = 0;
    var tickLen = (TICK_OUT - TICK_IN).toFixed(2);
    var lit = [];

    families.forEach(function (fam, fi) {
      var famStart = cursor;

      fam.cats.forEach(function (c, k) {
        var span = c.count * unit, c0 = cursor, c1 = cursor + span;

        glass.push(sector(c0, c1, CAT_IN, CAT_OUT, 1000));
        var arc = el('path', { d: sector(c0, c1, CAT_IN, CAT_OUT), 'class': 'us-dial__cat' });
        var t = el('title', {});
        t.textContent = c.name + ': ' + c.count + ' genes';
        arc.appendChild(t);
        svg.appendChild(arc);

        var mine = { name: c.name, arc: arc, ticks: [], mid: (c0 + c1) / 2 };
        lit.push(mine);

        var step = span / c.count;
        for (var i = 0; i < c.count; i++) {
          var ta = c0 + (i + 0.5) * step;
          var p0 = polar(TICK_IN, ta, 1), p1 = polar(TICK_OUT, ta, 1);
          svg.appendChild(el('line', {
            x1: p0[0].toFixed(2), y1: p0[1].toFixed(2),
            x2: p1[0].toFixed(2), y2: p1[1].toFixed(2),
            'class': 'us-dial__tick',
            style: '--i:' + tickIndex + ';--len:' + tickLen
          }));
          mine.ticks.push(svg.lastChild);
          tickIndex++;
        }

        cursor += span;
        if (k < fam.cats.length - 1) cursor += CAT_GAP;
      });

      glass.push(sector(famStart, cursor, GRP_IN, GRP_OUT, 1000));
      var farc = el('path', { d: sector(famStart, cursor, GRP_IN, GRP_OUT), 'class': 'us-dial__fam' });
      var ft = el('title', {});
      ft.textContent = fam.name + ': ' + fam.count + ' genes';
      farc.appendChild(ft);
      svg.appendChild(farc);

      if (fi < families.length - 1) cursor += GRP_GAP;
    });

    var clipId = 'us-dial-glass-' + (++uid);
    var defs = el('defs', {});
    var cp = el('clipPath', { id: clipId, clipPathUnits: 'objectBoundingBox' });
    glass.forEach(function (d) { cp.appendChild(el('path', { d: d })); });
    defs.appendChild(cp);
    svg.appendChild(defs);

    var box = root.querySelector('.us-dial__box');
    var pane = root.querySelector('.us-dial__glass');
    if (box) {
      if (!pane) {
        pane = document.createElement('div');
        pane.className = 'us-dial__glass';
        box.insertBefore(pane, box.firstChild);
      }
      pane.style.clipPath = 'url(#' + clipId + ')';
      pane.style.webkitClipPath = 'url(#' + clipId + ')';
    }

    var old = root.querySelectorAll('.us-dial__label');
    Array.prototype.forEach.call(old, function (n) { n.parentNode.removeChild(n); });

    var sides = [
      { names: list(root.getAttribute('data-left')),  arc: root.getAttribute('data-left-arc'),  fallback: [291, 231], side: 'left' },
      { names: list(root.getAttribute('data-right')), arc: root.getAttribute('data-right-arc'), fallback: [109, 133], side: 'right' }
    ];
    sides.forEach(function (s) {
      if (!s.names.length) return;
      var parts = list(s.arc).map(parseFloat);
      var from = isFinite(parts[0]) ? parts[0] : s.fallback[0];
      var to   = isFinite(parts[1]) ? parts[1] : s.fallback[1];
      var n = s.names.length;
      s.names.forEach(function (name, i) {
        var a = n === 1 ? (from + to) / 2 : from + (to - from) * (i / (n - 1));
        var rad = a * Math.PI / 180;
        var span = document.createElement('span');
        span.className = 'us-dial__label us-dial__label--' + s.side;
        span.style.setProperty('--sin', Math.sin(rad).toFixed(4));
        span.style.setProperty('--cos', Math.cos(rad).toFixed(4));
        span.style.setProperty('--i', i);
        span.textContent = name;
        root.appendChild(span);
      });
    });
    place(root);
    spotlight(root, lit);

    var coming = list(root.getAttribute('data-right')).concat(list(root.getAttribute('data-left')));
    root.setAttribute('role', 'img');
    root.setAttribute('aria-label',
      'A dial of your genomic record. ' + total + ' genes are reported today across ' +
      families.map(function (g) { return g.name.toLowerCase(); }).join(', ') +
      '. The rest of the dial is left open for the reports that follow' +
      (coming.length ? ': ' + coming.join(', ') : '') + '.');

    return true;
  }

  function reveal(root) {
    if (!('IntersectionObserver' in window)) { root.classList.add('us-dial--in'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('us-dial--in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    io.observe(root);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-us-dial]'), function (root) {
      if (root.hasAttribute('data-us-dial-wired')) return;
      var tries = 0;
      (function attempt() {
        if (draw(root)) {
          root.setAttribute('data-us-dial-wired', '');
          reveal(root);
          if ('ResizeObserver' in window) new ResizeObserver(function () { place(root); }).observe(root);
          else window.addEventListener('resize', function () { place(root); });
          return;
        }
        if (++tries < 30) requestAnimationFrame(attempt);
      })();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
